module.exports = __webpack_public_path__ + "static/img/咨询.3ba661e3.svg";